import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InventoryFacilityLocationsQueryVariables = Types.Exact<{
  facilityId: Types.Scalars['String'];
}>;


export type InventoryFacilityLocationsQuery = { readonly __typename?: 'Query', readonly facilityLocations: ReadonlyArray<{ readonly __typename?: 'Location', readonly _id: string, readonly name: string }> };


export const InventoryFacilityLocationsDocument = gql`
    query inventoryFacilityLocations($facilityId: String!) {
  facilityLocations(input: {clinicUuids: [$facilityId], active: true}) {
    _id
    name
  }
}
    `;

/**
 * __useInventoryFacilityLocationsQuery__
 *
 * To run a query within a React component, call `useInventoryFacilityLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryFacilityLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryFacilityLocationsQuery({
 *   variables: {
 *      facilityId: // value for 'facilityId'
 *   },
 * });
 */
export function useInventoryFacilityLocationsQuery(baseOptions: Apollo.QueryHookOptions<InventoryFacilityLocationsQuery, InventoryFacilityLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryFacilityLocationsQuery, InventoryFacilityLocationsQueryVariables>(InventoryFacilityLocationsDocument, options);
      }
export function useInventoryFacilityLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryFacilityLocationsQuery, InventoryFacilityLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryFacilityLocationsQuery, InventoryFacilityLocationsQueryVariables>(InventoryFacilityLocationsDocument, options);
        }
export type InventoryFacilityLocationsQueryHookResult = ReturnType<typeof useInventoryFacilityLocationsQuery>;
export type InventoryFacilityLocationsLazyQueryHookResult = ReturnType<typeof useInventoryFacilityLocationsLazyQuery>;
export type InventoryFacilityLocationsQueryResult = Apollo.QueryResult<InventoryFacilityLocationsQuery, InventoryFacilityLocationsQueryVariables>;